import {ChangeEvent, FC, useEffect, useRef, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {enqueueSnackbar} from 'notistack'
import {Button} from '../../../../../../components/UI/Button'
import {ModalErrorUpload} from '../../../../../central/pages/componentes/Modal/ModalErrorUpload'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {
  getTemplateCheckOutService,
  uploadTemplateCheckOutService,
} from '../../../../services/checking.service'
import {TabModel} from '../../../../../../models'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import Poppup from '../../../../../../components/UI/Poppup'
import {
  getLoadMasiveId,
  getLoadPercentage,
  getTemplateCheckoutService,
  uploadTemplateCheckoutAsyncService,
} from '../../../../services/booking.service'

export const getSnackBar = (message: String, variant: boolean) => {
  enqueueSnackbar(message, {
    variant: variant ? 'success' : 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  })
}
const FormMasiveUploadCheckout: FC = () => {
  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState('')
  const {changeCurrentTabItem, currentTabItem} = useHoteleria()
  const [show, setShow] = useState(false)
  const [response, setResponse] = useState('')
  const [progress, setProgress] = useState(0)
  const [titleUpload, setTitleUpload] = useState('')
  const [showPoppup, setShowPoppup] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [loading, setLoading] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)
  const completeIntervalRef = useRef<number | null>(null)

  const handleShowDetail = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'table-checkout-summary',
      },
      noFormDetail: true,
    }
    changeCurrentTabItem(obj)
  }

  const handleGetTemplate = async () => {
    try {
      setLoadingDownload(true)
      const response = (await getTemplateCheckoutService()) as any
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Checkout-Plantilla.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingDownload(false)
    } catch (error) {
      getSnackBarToast('Hubo un error', 'error')
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setError('')
    setProgress(0)
  }

  const handleUpload = async () => {
    try {
      if (file) {
        setError('')
        const formData = new FormData()
        formData.append('test', file)
        const obj: TabModel = {
          ...currentTabItem,
          trayUpdated: false,
        }
        changeCurrentTabItem(obj)
        setLoading(true)
        setShowPoppup(true)
        setTitleUpload('Cargando archivo...')
        const respId = await getLoadMasiveId()
        if (!respId.data.error) {
          const bulkLoadId = respId?.data?.BulkLoadId
          uploadTemplateCheckoutAsyncService(formData, bulkLoadId) // Use the service to upload the file
          completeIntervalRef.current = window.setInterval(async () => {
            const response2 = await getLoadPercentage(bulkLoadId)
            if (response2.data.error) {
              setLoading(false)
              const obj: TabModel = {
                ...currentTabItem,
                trayUpdated: false,
              }
              clearInterval(completeIntervalRef.current!)
              setShowPoppup(false)
              setShow(true)
              changeCurrentTabItem(obj)
              const error = response2?.data?.MsgError?.toString() || ''
              setResponse(error)
            } else {
              if (
                response2.data.Paso2_Porcentaje === 100 &&
                response2.data.Paso1_Porcentaje === 100
              ) {
                clearInterval(completeIntervalRef.current!)
                setLoading(false)
                setShowPoppup(false)
                getSnackBarToast(
                  'Documento cargado correctamente, ingrese a la bandeja si tiene observaciones',
                  'success',
                )
                const obj: TabModel = {
                  ...currentTabItem,
                  trayUpdated: true,
                }
                changeCurrentTabItem(obj)
              } else {
                if (response2.data.Paso1_Porcentaje === 100) {
                  const pr2 = response2.data.Paso2_Porcentaje
                  setTitleUpload(
                    'Se está cargando la información, espere un momento mientras termine de procesar ...',
                  )
                  setProgress(pr2)
                } else {
                  if (
                    response2?.data?.Paso1_Porcentaje !== null &&
                    response2?.data?.Paso1_Porcentaje !== undefined
                  ) {
                    const pr = response2.data.Paso1_Porcentaje
                    setTitleUpload('Se estan validando los datos del archivo...')
                    setProgress(pr)
                  } else {
                    clearInterval(completeIntervalRef.current!)
                    getSnackBarToast('Hubo un error', 'error')
                    setLoading(false)
                    setShowPoppup(false)
                    setFile(null)
                    setProgress(0)
                  }
                }
              }
            }
          }, 2000)
        } else {
          setLoading(false)
          setShowPoppup(false)
          setProgress(0)
          setFile(null)
          getSnackBarToast('Hubo un error', 'error')
        }

        if (fileInputRef.current) {
          fileInputRef.current.value = '' // Borra la selección de archivo
        }

        setFile(null)
      } else {
        changeCurrentTabItem({...currentTabItem, trayUpdated: false})

        setError('Este campo es requerido')
        console.error('No file selected.')
      }
    } catch (error) {
      // clearInterval(completeIntervalRef.current!)
      setLoading(false)
      setShowPoppup(false)
      setProgress(0)
      setFile(null)
      getSnackBarToast('Hubo un error', 'error')
    }
  }

  const handleClosePoppup = () => {
    if (completeIntervalRef.current !== null) {
      clearInterval(completeIntervalRef.current)
      completeIntervalRef.current = null
    }
    setFile(null)
    setShowPoppup(false)
    setLoading(false)
  }

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }, [])
  return (
    <>
      <KTCard shadow className='m-5'>
        <form>
          <div className='p-6'>
            <div className='d-flex'>
              <div className='col-6'>
                <div className='mb-3 col-10'>
                  <Button
                    onClick={handleGetTemplate}
                    label='Descargar Plantilla'
                    loading={loadingDownload}
                  />
                </div>
              </div>
              <div className='col-6 row'>
                <div className='d-flex h-40px justify-content-end'>
                  <Button onClick={handleShowDetail} label='Abrir Bandeja' />
                </div>
              </div>
            </div>
            <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
              <label className='required form-label'>Examinar</label>
              <div className='input-group input-group-sm'>
                <input
                  className='form-control'
                  type='file'
                  id='formFileRoom'
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
              </div>
              {showPoppup && (
                <Poppup
                  progress={progress}
                  text={titleUpload}
                  hasClose
                  handleClose={handleClosePoppup}
                />
              )}
              {error && <p className='error-message'>{error?.toString()}</p>}
            </div>
          </div>

          <div className='d-flex justify-content-center mb-3'>
            <Button onClick={handleUpload} label='Subir Archivo' disabled={loading} />
          </div>
        </form>
        <ModalErrorUpload show={show} setShow={setShow} message={response} file={file} />
      </KTCard>
    </>
  )
}

export {FormMasiveUploadCheckout}
